import { Input } from "antd";
import Editor from "../editor/Editor";
import ImageField from "../media/ImageField";

export default function KeywordValueInput({ type, value, onChange }) {
  switch (type) {
    case "EDITOR":
      return (
        <Editor
          value={value}
          onChange={(data) => onChange?.(JSON.stringify(data))}
          minHeight={200}
          className="form-editor"
        />
      );
    case "IMAGE":
      return <ImageField value={value} onChange={onChange} />;
    case "URL":
      return (
        <Input
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder="https://... эсвэл mailto:..."
        />
      );
    default:
      return (
        <Input.TextArea
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          autoSize={{ minRows: 2, maxRows: 8 }}
        />
      );
  }
}
